import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

/**
 * Fetches all the necessary data for the club portal dashboard in a single call.
 * @param {function} callback - The function to call with the response.
 */
export const getDashboardData = async (callback) => {
    try {
        // The route is just /api/dashboard, as defined in routes/api.php
        const response = await risapi.get('/api/dashboard', getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

